const EMPTY_PLACEHOLDER = '-'

export default EMPTY_PLACEHOLDER
